import { render } from "./AddEmployeeReview.vue?vue&type=template&id=3e69cf84&ts=true"
import script from "./AddEmployeeReview.vue?vue&type=script&lang=ts"
export * from "./AddEmployeeReview.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__